import { safetyHandler } from '../enums/utils';

export const ContextName = new Proxy(
  {
    TRACKING: 'TRACKING',
    LDT_ENV: 'LDT_ENV',
    USER_AGENT: 'USER_AGENT',
    COUNTRY_CODE: 'COUNTRY_CODE',
    EXPERIMENTS: 'EXPERIMENTS',
    COOKIES: 'COOKIES',
    USER_SELECTED_LOCALE: 'USER_SELECTED_LOCALE',
    UPDATE_EXPERIMENTS: 'UPDATE_EXPERIMENTS',
    PARTNER_SESSION: 'PARTNER_SESSION',
    LOCATION: {
      NAME: 'LOCATION_NAME',
      LATITUDE: 'LOCATION_LATITUDE',
      LONGITUDE: 'LOCATION_LONGITUDE',
      UPDATE_COORDS: 'LOCATION_UPDATE_COORDS',
      UPDATE_NAME: 'LOCATION_UPDATE_NAME',
      ACCURACY: 'LOCATION_ACCURACY',
      STATUS: 'LOCATION_STATUS',
      BROWSER_GEO_QUERYABLE: 'LOCATION_BROWSER_GEO_QUERYABLE',
      UPDATE_BROWSER_GEO_QUERYABLE: 'LOCATION_UPDATE_BROWSER_GEO_QUERYABLE',
    },
  },
  safetyHandler('ContextName'),
);
